import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

// const head = { "Content-Type": "multipart/form-data" };
// const instance2 = axios.create({
//   baseURL: apihostname,
//   headers: { ...authHeader(), ...head },
// });

class AcademyService {
  getAcademyByPersonId(id) {
    return instance.get("/academy/memberbycard/" + id);
  }
  getTableByAcademyId(id) {
    return instance.get("/get_assoc_by_id/" + id);
  }
  checkMember(idcard, assoc_id) {
    return instance.get("/academy/check/" + idcard + "/" + assoc_id);
  }
  createMember(body) {
    return instance.post("/academy/member", body);
  }
  deleteMember(member_id) {
    return instance.delete("/academy/member/" + member_id);
  }
  getAcademyList() {
    return instance.get("/academy");
  }
  getAcademyById(id) {
    return instance.get("/academy/" + id);
  }
}

export default new AcademyService();
